import { call, put, takeLatest } from "redux-saga/effects";
import {
  createSubjectStart,
  createSubjectSuccess,
  createSubjectFailure,
} from "../reducer";
import { Notify } from "@flexisaf/flexibull2";
import { postSubject } from "../../../services/subject";

export function* createSubject({ payload }) {
  const { name, description, curriculum, cb } = payload;

  const response = yield call(postSubject, { name, curriculum, description });
  const { success, raw, message } = response;

  if (success) {
    yield put(createSubjectSuccess());
    Notify("Subject created successfully", { status: "success" });
    if (cb) {
      cb();
    }
  } else {
    yield put(createSubjectFailure(message || raw.error));
    Notify(message || raw.error, { status: "error" });
  }
}

export default function* onCreateSubject() {
  yield takeLatest(createSubjectStart.type, createSubject);
}
